/// <amd-module name="SuiteCommerce.Blog.BlogHome.Model"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.BlogHome.Model", ["require", "exports", "Backbone", "SuiteCommerce.Blog.Post.Collection"], function (require, exports, Backbone_1, Post_Collection_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var BlogHomeModel = /** @class */ (function (_super) {
        __extends(BlogHomeModel, _super);
        function BlogHomeModel() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(BlogHomeModel.prototype, "featuredPosts", {
            get: function () {
                if (!this.get('featuredPosts')) {
                    this.featuredPosts = new Post_Collection_1.PostCollection();
                }
                return this.get('featuredPosts');
            },
            set: function (featuredPosts) {
                this.set('featuredPosts', featuredPosts);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(BlogHomeModel.prototype, "posts", {
            get: function () {
                if (!this.get('posts')) {
                    this.posts = new Post_Collection_1.PostCollection();
                }
                return this.get('posts');
            },
            set: function (posts) {
                this.set('posts', posts);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(BlogHomeModel.prototype, "headerBlockPostList", {
            get: function () {
                return new Post_Collection_1.PostCollection(this.posts.slice(0, 2));
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(BlogHomeModel.prototype, "contentPostList", {
            get: function () {
                return new Post_Collection_1.PostCollection(this.posts.slice(2));
            },
            enumerable: true,
            configurable: true
        });
        return BlogHomeModel;
    }(Backbone_1.Model));
    exports.BlogHomeModel = BlogHomeModel;
});
